import { useState, useContext } from 'react'
import { useMutation } from "@apollo/client";
import { useDisclosure } from "@chakra-ui/react";
import { useApolloClient } from "@apollo/client";
import { CANCEL_SUBSCRIPTION_PLAN, CUSTOMER_PORTAL } from "../../graphql/mutations";
import { USER_PUBLISHER_ROLE } from '../../graphql/queries';
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';


export const useBilling = () => {
    const { user, publisher, updatePublisherState } = useContext(PublisherAndUserContext);
    const [loading, setLoading] = useState(false);
    const apolloClient = useApolloClient();
    const {
        isOpen,
        onOpen,
        onClose
    } = useDisclosure();
    const {
        isOpen: cancelPlanIsOpen,
        onOpen: cancelPlanOnOpen,
        onClose: cancelPlanOnClose
    } = useDisclosure();

    const [cancelSubscriptionPlan] = useMutation(CANCEL_SUBSCRIPTION_PLAN, {
        onCompleted: () => {
            const exisiting = apolloClient.cache.readQuery({
                query: USER_PUBLISHER_ROLE, variables: {
                    where: {
                        email: user.email
                    }
                }
            })
            if (exisiting?.edShopifyUserAndPublisher) {
                apolloClient.cache.writeQuery({
                    query: USER_PUBLISHER_ROLE,
                    data: {
                        ...exisiting?.edShopifyUserAndPublisher,
                        publisher: {
                            ...exisiting?.edShopifyUserAndPublisher?.publisher,
                            accountType: "Free",
                            subscriptionInfo: {
                                ...exisiting?.edShopifyUserAndPublisher?.publisher?.subscriptionInfo,
                                frequency: null,
                                startDate: null,
                                subscriptionId: null,
                                price: 0,
                            }
                        }
                    }
                })
                updatePublisherState({
                    ...publisher,
                    isPro: false,
                    accountType: "Free",
                    subscriptionInfo: {
                        ...publisher?.subscriptionInfo,
                        frequency: null,
                        startDate: null,
                        subscriptionId: null,
                        price: 0,
                    }
                })
            }
            setLoading(false)
            cancelPlanOnClose()
        },
        error: () => {
            setLoading(false);
        },
    });

    const [getStripeCustomerPortalUrl] = useMutation(CUSTOMER_PORTAL, {
        onCompleted: (data) => {
            setLoading(false)
            window.open(data.edshopifyCustomerPortalForPublisher.url, "_self")
        },
        error: () => {
            setLoading(false);
        },
    });

    const getCustomerPortalUrl = () => {
        setLoading(true)
        getStripeCustomerPortalUrl({
            variables: {
                where: {
                    id: publisher.id
                }
            }
        })
    }

    const downgradeToFree = () => {
        setLoading(true);
        cancelSubscriptionPlan({
            variables: {
                where: {
                    id: publisher.id
                }
            }
        })
    }

    return {
        isOpen,
        onOpen,
        onClose,
        loading,
        downgradeToFree,
        publisher,
        cancelPlanIsOpen,
        cancelPlanOnOpen,
        cancelPlanOnClose,
        getCustomerPortalUrl
    }
}
